export default __webpack_public_path__ + "static/img-team-6-454450bdfc9c7f1b1716178420d261aa.png";